import { render, staticRenderFns } from "./point-of-sale.vue?vue&type=template&id=bba791da&scoped=true"
import script from "./point-of-sale.vue?vue&type=script&lang=js"
export * from "./point-of-sale.vue?vue&type=script&lang=js"
import style0 from "./point-of-sale.vue?vue&type=style&index=0&id=bba791da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bba791da",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PosFeatures: require('/home/rohit/Documents/GitHub/aibuddha-website/components/pos/PosFeatures.vue').default,PosFeaturesMobileView: require('/home/rohit/Documents/GitHub/aibuddha-website/components/pos/FeaturesMobileView.vue').default,Testimonials: require('/home/rohit/Documents/GitHub/aibuddha-website/components/Testimonials.vue').default,MidBanner: require('/home/rohit/Documents/GitHub/aibuddha-website/components/MidBanner.vue').default})
